export default {
  install(Vue) {
    const hub = new Vue();
    Vue.prototype.$onEvent = (name, func) => hub.$on(name, func);
    Vue.prototype.$emitEvent = (name, func) => hub.$emit(name, func);
  }
};



// WEBPACK FOOTER //
// ./src/plugins/EventHub.js